import { Modal as AntModal, ModalProps } from "antd";
import styled from "styled-components";

export const Modal: typeof AntModal = styled(AntModal)<ModalProps>``;
